export const MAIN_BUTTON = 0;
export const THROTTLE = 15;
export const MIN_DISTANCE = 5;

export const DEFAULT_STROKE_WIDTH = 2;
export const DEFAULT_ERASER_WIDTH = 50;
